import { createFileRoute } from '@tanstack/react-router'
import { SuccessChangePassAccount } from '@/pages/account/components/SuccessChangePassAccount'

export const Route = createFileRoute('/success-change-pass-account')({
  component: RouteComponent,
})

function RouteComponent() {
  return <SuccessChangePassAccount />
}
